import React, { Component, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Card,
  Typography,
  Divider,
  CardContent,
  CardHeader,
  Container,
  Box,
  Tooltip,
} from "@material-ui/core";
import cardlogo from "../../../Assets/img/svg/ShipCard.svg";
import Paper from "@material-ui/core/Paper";
import DeleteIcon from "@material-ui/icons/Delete";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import filterIcon from "../../../Assets/img/svg/FilterIcon.svg";
import { useNavigate } from "react-router-dom";
import FilterIcon from "../../../Assets/img/svg/FilterIcon.svg";
import Autocomplete from "react-autocomplete";
import moment from "moment";
import axios from "axios";
import API from "../../../helpers/endpointService";
import $ from "jquery";
import { withStyles } from "@material-ui/core";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "../../../Assets/jss/customStyle";
import withRouter from "../../custom/withRouter";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import {warningAlert} from "../../custom/alert"
import { VesselStatus, inspectionSystem, inspectionType, isUserRole } from "../../Constants";
import { getShipTypeList, getStatusTypeList, getInspectionTypeList } from "../../../actions/Lookup";

class SampleShipListview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      isEdit: false,
      search: false,
      UserRole: "",
      menu: true,
      projectList: [],
      Ships: [],
      open: true,
      searchData: {
        UserEmail: "",
        Shipname: "",
        Status: "",
        IsSample : true,
        PageNumber: 1,
        PageSize: 100,
      },
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    this.state.UserRole = localStorage.getItem("UserRoles");
    this.state.searchData.UserEmail = JSON.parse(localStorage.getItem("currentUser")).email;
    this.setState({});
    if(this.state.UserRole == "Client"||this.state.UserRole=="External Client"){
      this.state.searchData.Status = "Reviewed and Approved"
    }
    this.setState({})
    dispatch(getStatusTypeList(VesselStatus.Status));
    dispatch(getInspectionTypeList(VesselStatus.InspectionType));
    this.getShipList(this.state.searchData);
    this.getShipListNames(this.state.searchData);
    this.interval = setInterval(() => {
      this.resize();
    }, 10);
    localStorage.removeItem("DashId");
    localStorage.removeItem("addeditid");
    localStorage.removeItem("ShipName");
   
  }

  componentWillUnmount() {
    clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#SSHIP1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#ExterMngt0 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#ExterMngt00").addClass("d-none");
        $("#ExterMngt00").removeClass("d-block");
  }

  sidebar = () => {
    if (this.state.isEdit == "true") {
      this.props.navigate("/sidebareditship");
    } else {
      this.props.navigate("/sidebaraddship");
    }
  };

  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
    $("#SSHIP1 .MuiListItemText-primary").addClass("spanTopBar")
    $("#ExterMngt0 .MuiListItemText-primary").addClass("fw-bolder");
    $("#ExterMngt00").removeClass("d-none");
    $("#ExterMngt00").addClass("d-block");
    $("#EOPAT .MuiListItemText-primary").addClass("fw-bolder")
    $("#EOPA").addClass("active-color")
   
    // this.props.dispatch(getlookupdocinfo("Status"))
  };

 

  EditPage = (e) => {
    this.props.dispatch({ type: "CANCEL", data: false });
    localStorage.removeItem("DashId");
    localStorage.setItem("DashId", e);
    this.props.navigate(`/shipparticulars/edit`);
  };

  handleAnnualSelectChange = (e) => {
    this.state.searchData.Status = e;
    this.setState({});
  };
  ProjectStatusSelectChange(e) {
    this.state.search = true;
    this.state.searchData.Status = e.target.value;
    this.setState({});
  }
  renderProjectNames = (state, val) => {
    return state?.Shipname?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  };
  handleProjectNameSearchChange = (e) => {
    this.state.searchData.Shipname = e.target.value;
    this.setState({});
  };
  handleProjectNameSelectChange = (e) => {
    this.state.searchData.Shipname = e;
    this.setState({});
  };


  getShipList = (data) => {
    let apiUrl = API.GET_SHIP + "?Shipname=" + data.Shipname + "&Status=" + data.Status + "&IsSample=" + data.IsSample +"&UserEmail=" + data.UserEmail + "&PageNumber=" + data.PageNumber + "&PageSize=" + data.PageSize;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.state.projectList = response.data;
          this.setState({});
        } else {
        }
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        warningAlert("Something went wrong. Please try again.");
        if (error?.response?.status === 401) {
          this.props.dispatch({ type: "SHOW_LOADER", data: false })
        }
      });
  };

  getShipListNames = () => {
    let apiUrl = API.GET_SHIPNAMES;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.state.Ships = response.data;
          this.setState({});
        } else {
        }
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        warningAlert("Something went wrong. Please try again.");
        if (error?.response?.status === 401) {
          this.props.dispatch({ type: "SHOW_LOADER", data: false })
        }
      });
  };

  DashboardNavigation(e, item) {
    localStorage.setItem("DashId", e);
    localStorage.setItem("ShipName", item.ShipName);
    localStorage.setItem("IMONumber", item.IMONumber);
    localStorage.setItem("InspectionId", item.InspectionId);
      this.props.navigate(`/shipparticulars/edit`);
  }

  render() {
    const { isEdit, projectList } = this.state;
    let { Lookup_data, classes, shipList, shipNames, menuToggle } = this.props;
    return (
      <>
        {this.state.isMobile ? (
          <>
            <div className="row w-100 mt-4 mob-topfixed  border-bottom">
              <div className="col-6 mt-auto">
                <List
                  className="pt-4 mt-4 "
                  style={{ backgroundColor: "#F6F6F6" }}
                >
                  <ListItem>
                    <ListItemText
                      id={"SSHIP" + "1"}
                      className=" textNaviIcon"
                      primary="External Client Ships"
                    />
                    <NavigateNextIcon
                      id="SSHIP"
                      className="naviIcon ml-1"
                      style={{ width: 23, height: 23 }}
                    />
                    <Divider className="border-bottom" />
                  </ListItem>
                </List>
              </div>
              <div className="col-6 pt-2 mt-5">
                <h4 className="pt-2"> Sample Ships</h4>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
        <div
          className=" ml-auto mt-138"
          style={{
            backgroundColor: "#FFFFFF",
            width: this.state.isMobile
            ? "100%"
            : menuToggle
            ? "calc(100% - 240px)"
            : "calc(100% - 64px)",
            marginTop: this.state.isMobile ? "" : -75,
          }}
        >
          
          <Container
            className={`${window.innerWidth >= 850 ? " top-fixe" : ""}`}
            maxWidth="false"
            style={{
              paddingLeft: 40,
              paddingRight: 40,
              backgroundColor: "white",
              marginTop: this.state.isMobile ? "" : "",
            }}
          >
            <Grid container spacing={3} className="mt-2">
              <Grid item xs={12} md={12} lg={12}>
                <div className="row">
                  <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                    {this.state.isMobile ? (
                      <></>
                    ) : (
                      <h6 className="col-12" style={{ marginLeft: "-15px" }}> {localStorage.getItem("UserRoles") == "External Client"? "Ships" :"Sample Ships"}</h6>
                    )}
                  </div>
                  <div className="col-6 col-sm-6 col-md-6 col-lg-6 text-end m-auto">
                 
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              className={
                window.innerWidth < 1280 ? "d-flex container-lg mx-lg-auto" : ""
              }
            >
              {projectList &&
                projectList?.Ship &&
                projectList?.Ship.map((item, index) => (
                  ((localStorage.getItem("UserRoles") == "FieldInspector" && (item.Status === "Inspection Completed" || item.Status === "Reviewed and Approved")) || (localStorage.getItem("UserRoles") == "Client" && item.Status != "Reviewed and Approved")) ?  <></> :
                  <>
                    <Grid
                      className={classes.gridItem}
                      item
                      xs={12}
                      sm={6}
                      md={6}
                      lg={3}
                      xl={3}
                    >
                      <Card
                        className={classes.card}
                        style={{ backgroundColor: "#499AC8", color: "#FFFFFF" }}
                      >
                        <CardContent className={classes.cardContent}>
                          <div
                            className="row cursorPointer"
                            onClick={() =>
                              this.DashboardNavigation(item?.ShipId, item)
                            }
                          >
                            <div className="col-sm-12 col-12 fw-normal overflow fw-bold f-size-14">
                              {item?.ShipName}
                            </div>
                          </div>

                          <Divider
                            className="mt-2"
                            style={{ backgroundColor: "#212121e3" }}
                          />
                          <Box
                            display={"flex"}
                            mt={1}
                            mb={0}
                            className="row cursorPointer "
                            // style={{ minHeight: "150px" }}
                            onClick={() =>
                              this.DashboardNavigation(item?.ShipId,item)
                            }
                          >
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                              <Box color="" className="row mt-auto">
                                <p
                                  className="col-sm-5 col-6 col-md-6 col-lg-6 pr-0"
                                  style={{ color: "#f9f9f9eb" }}
                                >
                                  Client
                                </p>
                                <p className="col-sm-7 col-6 col-md-6 col-lg-6 pl-1 fw-bold overflow">
                                  {item.ShipIncharge?.ClientName}
                                </p>
                              </Box>
                              <Box color="" className="row mt-auto">
                                <p
                                  className="col-sm-5 col-6 col-md-6 col-lg-6 pr-0"
                                  style={{ color: "#f9f9f9eb" }}
                                >
                                  Field Inspector
                                </p>
                                <p className="col-sm-7 col-6 col-md-6 col-lg-6 pl-1 overflow fw-bold">
                                  {item.ShipIncharge?.FieldInspectorName}
                                </p>
                              </Box>
                              <Box color="" className="row mt-auto">
                                <p
                                  className="col-sm-5 col-6 col-md-6 col-lg-6 pr-0"
                                  style={{ color: "#f9f9f9eb" }}
                                >
                                  Inspection Type
                                </p>
                                <p className="col-sm-7 col-6 col-md-6 col-lg-6 pl-1 fw-bold text-left">
                                  {item.InspectionType == inspectionType.PreSale ? "Pre-Sale Inspection" : item.InspectionType == inspectionType.PrePurchase ? "Pre-Purchase Inspection" : item.InspectionType == inspectionType.VesselCondition ? "Vessel Condition" : ""}
                                  <br></br>
                                </p>
                              </Box>
                            </div>
                          </Box>
                         
                          <Divider
                            className="mb-2"
                            style={{ backgroundColor: "#212121e3" }}
                          />
                          <div className="row" style={{ height: "30px" }}>
                          {localStorage.getItem("UserRoles") == "External Client"?<>
                          <div className="col-sm-8 col-8 text-left fw-bold "></div>
                          <div className="col-sm-4 col-4 text-right">
                          <button
                              type="button"
                              class={
                                this.state.isMobile
                                  ? "btn btn-secondary"
                                  : " btn btn-secondary py-2 px-4"
                              }
                             
                              style={{
                                backgroundColor: "#499AC8",
                                border: "none",
                                
                              }}
                              onClick={() =>
                                this.DashboardNavigation(item?.ShipId,item)
                              }
                            >
                              <span className="">View</span>
                            </button></div></>:
                          <>
                            <div className="col-sm-10 col-10 text-left fw-bold ">
                              {item?.Status}
                            </div>
                            <div className="col-sm-2 col-2 text-right">
                              <Tooltip title="Edit" placement="top" arrow>
                                <NavigateNextIcon
                                  className="float-end cursorPointer"
                                  onClick={() =>
                                    this.DashboardNavigation(item?.ShipId,item)
                                  }
                                />
                              </Tooltip>
                            </div></>}
                          </div>
                        </CardContent>
                      </Card>
                    </Grid>
                  </>
                ))}
            </Grid>
          </Container>
        </div>
        <div class="modal left fade pt-5 mt-3" id="custom-modal" tabIndex={-1} role="dialog" aria-hidden="true">

          <div
            className="modal-dialog modal-dialog-centered"
            style={{ width: this.state.isMobile ? "250px" : "" }}
          >
            <div className="modal-content border-radius">
              <div className="modal-header">
                <div className="row m-0">
                  <h6 className="modal-title" id="myCenterModalLabel">
                    Advanced Filter
                  </h6>
                  <div className="col-12">
                    <span
                      className="cursorPointer"
                      onClick={() => this.ResetFilter()}
                    >
                      <img src={FilterIcon} />
                      &nbsp;<span>Reset to default</span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="modal-body p-4">
                <form id="myform">
                  <div className="form-group row">
                    <div className="col-5 m-auto">
                      <label htmlFor="name">Ship Name</label>
                    </div>
                    <div className="col-7">
                      <div className="autocomplete-wrappers">
                        <Autocomplete
                          contentEditable={true}
                          value={this.state.searchData.Shipname}
                          inputProps={{
                            placeholder: "Ship Name",
                          }}
                          items={this.state.Ships ?? []}
                          getItemValue={(item) => item.ShipName}
                          shouldItemRender={this.renderProjectNames.bind(this)}
                          renderMenu={(item) => (
                            <div className="dropdowns d-block">{item}</div>
                          )}
                          renderInput={(props) => {
                            return (
                              <input
                                className="form-control border-radius"
                                id="exampleFormControlInput1"
                                {...props}
                                style={{
                                  height: 32,
                                  fontSize: 12,
                                  color: "#000000",
                                }}
                              />
                            );
                          }}
                          renderItem={(item, isHighlighted) => (
                            <div
                              className={`items 
                                                        ${isHighlighted
                                  ? "selected-items"
                                  : ""
                                }`}
                            >
                              {item.ShipName}
                            </div>
                          )}
                          onChange={(e) =>
                            this.handleProjectNameSearchChange(e)
                          }
                          onSelect={(e) =>
                            this.handleProjectNameSelectChange(e)
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-5 m-auto">
                      <label htmlFor="name">Report Status</label>
                    </div>
                    <div className="col-7 ">
                      <select
                        className="form-control border-radius"
                        onChange={(e) => this.ProjectStatusSelectChange(e)}
                        value={this.state.searchData.Status}
                      >
                        <option value="">Select Status</option>
                        {this.props.statusType &&
                          this.props.statusType.map((i, ind) => {
                            return <option value={i.Name}>{i.Name}</option>
                          })}
                      </select>
                    </div>
                  </div>
                  <div className="row text-center mt-4">
                    {this.state.isMobile ? (
                      <></>
                    ) : (
                      <div className="col-2"></div>
                    )}
                    <div
                      className={this.state.isMobile ? "col-6" : "col-5"}
                      data-dismiss="modal"
                    >
                      <button
                        type="button"
                        className={`btn btn-primary input-group border-radius f-size-13 ${this.state.isMobile
                          ? " filter-Mobilebtn"
                          : "filter-btn"
                          }`}
                        data-bs-toggle="modal"
                        style={{ backgroundColor: "#499AC8", color: "#FFFFFF" }}
                        onClick={() => this.filterSearch()}
                      >
                        Search
                      </button>
                    </div>
                    <div
                      className={this.state.isMobile ? "col-6" : "col-5"}
                      data-dismiss="modal"
                    >
                      <button
                        data-bs-dismiss="modal"
                        type="button"
                        id="closemodal"
                        className={`btn btn-light input-group border-radius f-size-13 ${this.state.isMobile
                          ? " filter-Mobilebtn"
                          : "filter-btn"
                          }`}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
    // shipStatus: state.projectReducer.shipStatus || [],
    // shipList: state.projectReducer.shipList || [],
    // shipNames: state.projectReducer.shipNames || [],
    statusType: state.lookupReducer.statusType || [],
    inspectionType: state.lookupReducer.inspectionType || []
  };
}

SampleShipListview.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(SampleShipListview))
);
